export default __webpack_public_path__ + "static/media/twitter.95ba9be6.png";